var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center mt-5 fs-14 fs-md-16 text-gray"},[_c('v-icon',{attrs:{"color":"#b2b2c2"}},[_vm._v(" mdi-arrow-down ")]),_c('span',{staticClass:"text-gray ml-2"},[_vm._v(" "+_vm._s(_vm.$t('labels.scrollDownToLoad'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }